import CanRiskCanRiskResultRecipe_1_0_0 from './CanRiskResultRecipe_1_0_0.js';
const QuestionnaireRecipes = [...CanRiskCanRiskResultRecipe_1_0_0];
export default QuestionnaireRecipes;
export const latestVersionCanRiskResult = 'CanRiskResult';
const supported = ['CanRiskResult'];
export const canRiskResultVersions = [...supported];
export const canRiskResultVersionsTypes = [...supported];
//# sourceMappingURL=CanRiskResultRecipes.js.map